var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressIndicator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 30,
    viewBox: "0 0 17 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFBE00"
  }, /*#__PURE__*/React.createElement("path", {
    strokeDasharray: "4,4",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8.249 27V1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE00",
    d: "M8.5 16L16 29H1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressIndicator);
export default __webpack_public_path__ + "static/media/progress-indicator.05905a0ef3a0c36d008c917fa5b4948b.svg";
export { ForwardRef as ReactComponent };